import { Component, Input, Output, EventEmitter, inject, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Entity } from '../../../../core/data-models/Entity';
import { PerformanceRate } from '../../../../core/data-models/performance-rate';
import { LanguageService } from '../../../../core/services/language.service';
import { ModuleName } from '../../../../shared/enums/ModuleName';
import { ThemeModule } from '../../../../shared/Theme/theme.module';
import { ChildrenAnimation, inOutAnimation, slidesAniamtion } from '../../../../shared/animations/allAnimations';
import { faStar } from '@fortawesome/free-solid-svg-icons';

export interface PerformanceTableOptions {
    data: PerformanceRate[];
    columns: { field: string; title: string }[];
}

/**
 * Performance Rate Settings Component
 * 
 * Handles CRUD operations for performance rates including:
 * - Display performance rates in a table
 * - Add new performance rate
 * - Edit existing performance rate
 * - Delete performance rate
 */
@Component({
    selector: 'performance-rate-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ThemeModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    templateUrl: './performance-rate-settings.component.html',
    styleUrls: ['./performance-rate-settings.component.scss'],
    animations: [inOutAnimation, slidesAniamtion, ChildrenAnimation]
})
export class PerformanceRateSettingsComponent {
    private languageService = inject(LanguageService);

    readonly ModuleNames = ModuleName;
    faStar = faStar;

    @Input() selectedEntity!: Entity;
    @Input() language: string = 'EN';
    @Input() performanceOptions!: PerformanceTableOptions;

    @Output() addPerformance = new EventEmitter<void>();
    @Output() editPerformance = new EventEmitter<{ index: number; item: PerformanceRate }>();
    @Output() deletePerformance = new EventEmitter<{ index: number; item: PerformanceRate }>();

    /**
     * Extract name in current language from translation array
     */
    extractNameLanguage(name: any): string {
        return this.languageService.extractNameLanguage(name);
    }

    onAddPerformance(): void {
        this.addPerformance.emit();
    }

    onEditPerformance(index: number, item: PerformanceRate): void {
        
        this.editPerformance.emit({ index, item });
    }

    onDeletePerformance(index: number, item: PerformanceRate): void {
        this.deletePerformance.emit({ index, item });
    }
}
